export const CRYPTO_REWARDS_API_ENDPOINT_MAIN = '/api/v1/crypto'

export const GET_CRYPTO_CURRENCIES_META_URL = `${ CRYPTO_REWARDS_API_ENDPOINT_MAIN }/currencies/` as const

export const GET_CRYPTO_CURRENCIES_MARKET_DATA_URL = `${ CRYPTO_REWARDS_API_ENDPOINT_MAIN }/currencies/market_data/` as const

export const GET_CRYPTO_REWARDS_ORDERS = `${ CRYPTO_REWARDS_API_ENDPOINT_MAIN }/orders/` as const

export const POST_ORDER_BUY_CRYPTO_URL = `${ CRYPTO_REWARDS_API_ENDPOINT_MAIN }/orders/buy/` as const

export const GET_PREVIEW_ORDER_SELL_CRYPTO_URL = `${ CRYPTO_REWARDS_API_ENDPOINT_MAIN }/currencies/sell_preview/` as const

export const POST_ORDER_SELL_CRYPTO_URL = `${ CRYPTO_REWARDS_API_ENDPOINT_MAIN }/orders/sell/` as const

export const POST_CHANGE_AUTOINVESTMENTS_IN_CRYPTO_MODE_URL = `/api/v1/rewards/summary/patch/` as const
